const services = [
  {
    slug: 'ac-repair',
    eyebrow: 'Cooling Service',
    title: 'AC Repair & Cooling Service',
    pageTitle: 'Air conditioning repair that gets your home comfortable again.',
    seoTitle: 'AC Repair in South Jordan, UT | Preferred Service',
    seoDescription:
      'Get straightforward air conditioning diagnostics and AC repair in South Jordan and nearby Salt Lake County communities.',
    description:
      'Reliable air conditioning diagnostics and repair for cooling, airflow, and performance problems during hot Utah summers.',
    intro:
      'When an air conditioner stops keeping up, the first step is understanding whether the cause is airflow, electrical, refrigerant-related, or a worn component. We inspect the system, explain what we find, and discuss practical repair options.',
    signs: [
      'The system runs but the home stays warm',
      'Airflow is weak or rooms cool unevenly',
      'The equipment cycles frequently or will not start',
      'You notice unusual sounds, odors, or leaking around the unit',
    ],
    included: [
      'System and thermostat diagnostics',
      'Airflow and temperature checks',
      'Electrical and component inspection',
      'A clear explanation of repair options and next steps',
    ],
  },
  {
    slug: 'furnace-repair',
    eyebrow: 'Heating Service',
    title: 'Furnace & Heating Repair',
    pageTitle: 'Straightforward furnace repair for dependable winter comfort.',
    seoTitle: 'Furnace Repair in South Jordan, UT | Preferred Service',
    seoDescription:
      'Request furnace and heating repair for ignition, airflow, and comfort problems in South Jordan and nearby communities.',
    description:
      'Heating system diagnostics and repair for ignition problems, uneven heat, and winter breakdowns.',
    intro:
      'A heating problem can come from the thermostat, airflow, ignition, electrical controls, or the equipment itself. We work through the system methodically and explain the recommended repair before work moves forward.',
    signs: [
      'The furnace will not start or stay running',
      'The home heats slowly or unevenly',
      'The system makes new or unusually loud noises',
      'The air from the vents is cool or airflow has dropped',
    ],
    included: [
      'Heating system and thermostat diagnostics',
      'Ignition and safety-control inspection',
      'Airflow and filter checks',
      'Repair recommendations explained in plain language',
    ],
  },
  {
    slug: 'hvac-installation',
    eyebrow: 'System Replacement',
    title: 'HVAC System Installation',
    pageTitle: 'HVAC replacement guidance centered on the home and its comfort needs.',
    seoTitle: 'HVAC Installation South Jordan, UT | Preferred Service',
    seoDescription:
      'Plan an HVAC system replacement or installation for reliable home comfort in South Jordan and Salt Lake County.',
    description:
      'System replacement and installation planning with equipment selected for reliable, efficient comfort.',
    intro:
      'Replacement decisions should account for the home, the existing system, comfort concerns, and long-term priorities. We help compare appropriate options and plan an installation that fits the space rather than defaulting to a one-size-fits-all recommendation.',
    signs: [
      'Repairs are becoming more frequent or expensive',
      'The system cannot keep temperatures consistent',
      'The equipment is nearing the end of its useful life',
      'You want to compare comfort or efficiency improvements',
    ],
    included: [
      'Review of the existing system and comfort concerns',
      'Equipment and sizing recommendations',
      'Removal and replacement planning',
      'Startup checks and an overview of system operation',
    ],
  },
  {
    slug: 'preventive-maintenance',
    eyebrow: 'Seasonal Care',
    title: 'Preventive Maintenance',
    pageTitle: 'Seasonal HVAC maintenance that helps your equipment stay ready.',
    seoTitle: 'HVAC Maintenance South Jordan, UT | Preferred Service',
    seoDescription:
      'Schedule seasonal heating and cooling maintenance in South Jordan to inspect equipment and prepare for Utah weather.',
    description:
      'Heating and cooling tune-ups designed to spot wear, support performance, and reduce avoidable surprises.',
    intro:
      'Routine maintenance gives a technician a chance to inspect major components, check system operation, and identify developing concerns before the busiest heating or cooling weeks arrive.',
    signs: [
      'The system has not been inspected before the upcoming season',
      'Energy use or run times appear to be increasing',
      'Airflow or comfort has gradually changed',
      'You want a clearer picture of the system’s condition',
    ],
    included: [
      'Operating and safety-control checks',
      'Filter, airflow, and thermostat review',
      'Inspection of accessible system components',
      'A summary of maintenance findings and concerns',
    ],
  },
  {
    slug: 'indoor-air-quality',
    eyebrow: 'Healthier Indoor Air',
    title: 'Indoor Air Quality Solutions',
    pageTitle: 'Indoor air quality improvements chosen for the problems in your home.',
    seoTitle: 'Indoor Air Quality South Jordan, UT | Preferred Service',
    seoDescription:
      'Explore filtration, purification, humidity, and airflow solutions for South Jordan and Salt Lake County homes.',
    description:
      'Filtration, purification, humidity, and airflow options that can support a cleaner indoor environment.',
    intro:
      'Indoor air concerns do not all have the same cause. We start with what you are noticing, look at the HVAC system and airflow, and discuss options that fit the concern rather than adding equipment without a clear reason.',
    signs: [
      'Dust returns quickly after cleaning',
      'Seasonal dryness or humidity affects comfort',
      'Odors or stale air linger in the home',
      'You want to review filtration or purification options',
    ],
    included: [
      'Discussion of the home’s specific air concerns',
      'Review of filters, airflow, and system compatibility',
      'Filtration, purification, or humidity recommendations',
      'Clear guidance on operation and ongoing care',
    ],
  },
  {
    slug: 'ductless-mini-splits',
    eyebrow: 'Flexible Comfort',
    title: 'Ductless Mini Split Systems',
    pageTitle: 'Flexible heating and cooling for spaces without traditional ductwork.',
    seoTitle: 'Ductless Mini Splits South Jordan, UT | Preferred Service',
    seoDescription:
      'Explore ductless mini split installation and service for additions, garages, and comfort zones in South Jordan, Utah.',
    description:
      'Ductless mini split planning, installation, and service for additions, garages, and targeted comfort zones.',
    intro:
      'Ductless equipment can be a practical option when extending existing ductwork is difficult or when one area needs independent temperature control. We help determine whether the space and comfort goals are a good fit.',
    signs: [
      'An addition or converted space lacks ductwork',
      'A garage or work area needs independent comfort',
      'One part of the home is consistently too warm or too cool',
      'You want to explore zone-specific heating and cooling',
    ],
    included: [
      'Review of the space and comfort goals',
      'System placement and sizing recommendations',
      'Installation or service options',
      'Operating and care guidance for the equipment',
    ],
  },
];

export default services;
